import React, { useState, useContext, useRef, useEffect } from 'react'
import styles from './Header.module.css'
import MainLogo from '../../../../components/Logo/MainLogo'
import { Link } from 'react-router-dom'
import { Dropdown, Menu, Space, Modal, Tooltip, message, Switch } from 'antd'

import QRCodeGenerator from '../../../../components/QRCodeGenerator/QRCodeGenerator'

import {
  MobileOutlined,
  DesktopOutlined,
  TabletOutlined,
  LeftOutlined,
  SendOutlined,
  EllipsisOutlined,
  ExportOutlined,
} from '@ant-design/icons'
import {
  addCollaboratorAPI,
  updateCollaborator,
  deleteCollaborator,
  addRestrictedSubmissions,
  updateRestrictedSubmissions,
  deleteRestrictedSubmissions,
} from '../../../../services/api'
import { observer } from 'mobx-react-lite'
import AvatarRoles from '../../../../components/AvatarRoles/AvatarRoles'
import DefaultDesign from '../Settings/components/DefaultDesign/DefaultDesign'
import { useNavigate } from 'react-router-dom'
import DropdownProfile from '../../../../components/DropdownProfile/DropdownProfile'
import {
  Svg3PointsMore,
  SvgLogoMetropole,
  SvgCloseSidebarLeft,
  SvgCloseSidebarRight,
  SvgMobileView,
  SvgRedo,
  SvgUndo,
  SvgMoreInfo,
  SvgDesktopView,
  SvgPlay,
  SvgTabletView,
  SvgChangeColor,
  SvgCopyLink,
} from '../../../../components/svg/SvgComponents'

import { duplicateFormAPI } from '../../../../services/api'
import { BuilderContext } from '../store/store.Builder'
import { toJS } from 'mobx'
import { nanoid } from 'nanoid'

const Header = observer(() => {
  const history = useNavigate()
  const builderContext = useContext(BuilderContext)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false)

  const FORM_URL = `/viewform/${builderContext.url_code}/`
  const PREVIEW_FORM_URL = `/sandbox/${builderContext.url_code}/preview/`
  const RESPONSES_FORM_URL = `/sandbox/${builderContext.url_code}/answers/`

  const newTabRef = useRef(null)

  const showPublishModal = () => {
    setIsPublishModalOpen(true)
  }

  const handleOkPublish = () => {
    setIsPublishModalOpen(false)
  }
  const handleCancelPublish = () => {
    setIsPublishModalOpen(false)
  }

  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = () => {
    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const handleFormParams = () => {
    console.log('Clic dans le canvas/Form')
    builderContext.setSelectedField(builderContext.styleForm, 'form')
  }

  const handleFormDuplicate = async () => {
    try {
      const data = await duplicateFormAPI(builderContext.url_code)
      console.log('DATASURPERDATA', data.new_url_code)

      // Ouvrir un nouvel onglet avec le lien désiré
      const newUrl = `/sandbox/${data.new_url_code}/`
      window.open(newUrl, '_blank') // '_blank' pour ouvrir dans un nouvel onglet
    } catch (error) {
      // Gérer les erreurs comme vous le souhaitez.
    }
  }

  const handleFormDelete = async () => {
    try {
      const data = await duplicateFormAPI(builderContext.url_code)
      console.log('DATASURPERDATA', data.new_url_code)

      // Ouvrir un nouvel onglet avec le lien désiré
      const newUrl = `/sandbox/${data.new_url_code}/`
      window.open(newUrl, '_blank') // '_blank' pour ouvrir dans un nouvel onglet
    } catch (error) {
      // Gérer les erreurs comme vous le souhaitez.
    }
  }

  const items = [
    {
      label: <div onClick={showModal}>Design par défaut</div>,
      key: '-1',
    },
    {
      label: (
        <a target="_blank" rel="noopener noreferrer" href={PREVIEW_FORM_URL}>
          Aperçu du formulaire
        </a>
      ),
      key: '1',
    },
    {
      label: (
        <a target="_blank" rel="noopener noreferrer" href={FORM_URL}>
          Accéder au formulaire
        </a>
      ),
      key: '2',
    },
    {
      label: (
        <a
          onClick={handleFormParams}
          // href={`/workspaces`}
        >
          Paramètres du formulaire
        </a>
      ),
      key: '3',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <a
          onClick={handleFormDuplicate}
          // href={`/workspaces`}
        >
          Dupliquer le formulaire
        </a>
      ),
      key: '4',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <a href={RESPONSES_FORM_URL} target="_blank" rel="noopener noreferrer">
          Réponses
        </a>
      ),
      key: '5',
    },
  ]

  const renderCountRef = useRef(0)
  renderCountRef.current += 1

  useEffect(() => {
    console.log(`Header render count: ${renderCountRef.current}`)
  })

  const [selectedDevice, setSelectedDevice] = useState('Desktop')

  const handleButtonClick = (value) => {
    builderContext.changeCanvasSize(value)
    setSelectedDevice(value)
  }

  const handleToggleForm = (checked) => {
    try {
      const updatedStyleForm = {
        ...builderContext.styleForm,
        is_active: checked,
      }

      builderContext.handleUpdateForm(updatedStyleForm)
    } catch (error) {
      console.error('Erreur lors de la mise à jour du formulaire:', error)
    }
  }

  const handleCopyLink = () => {
    const link = `${window.location.origin}${FORM_URL}`

    navigator.clipboard
      .writeText(link)
      .then(() => {
        // Utilisez le message de Ant Design au lieu de console.log
        message.success('Le lien a été copié avec succès!')
      })
      .catch((error) => {
        // Vous pouvez également utiliser un message d'erreur d'Ant Design
        message.error('Erreur lors de la copie du lien.')
        console.error('Erreur lors de la copie du lien :', error)
      })
  }

  const devices = [
    { value: 'Desktop', svg: <SvgDesktopView /> },
    { value: 'Mobile', svg: <SvgMobileView /> },
    { value: 'Tablet', svg: <SvgTabletView /> },
  ]

  const SizeCanvasButtons = () => (
    <div className={styles.sizeCanvas__buttons_container}>
      <div className={styles.all_buttons}>
        {devices.map((device) => (
          <div
            key={device.value}
            className={`${styles.item__canvas} ${
              device.value === selectedDevice
                ? `${styles.selected} ${styles.selected__button}`
                : ''
            }`}
            onClick={() => handleButtonClick(device.value)}
          >
            <div className={styles.left_i__svg}>{device.svg}</div>
          </div>
        ))}
      </div>
    </div>
  )

  const formURL = `${window.location.origin}${FORM_URL}`

  return (
    <div className={styles.header}>
      <Modal
        centered
        title="Modification du design par défaut"
        open={isModalOpen}
        width={1000}
        onCancel={handleCancel}
        maskClosable={true}
        footer={null}
      >
        <DefaultDesign />
      </Modal>
      <div className={styles.left__container}>
        <a
          href={`/workspaces/`}
          // href={`/workspaces`}
          rel="noopener noreferrer"
        >
          <div className={styles.container_logo}>
            <div className={styles.logo_more}>
              <Svg3PointsMore />
            </div>
            <div className={styles.logo_metropole}>
              <SvgLogoMetropole />
            </div>
          </div>
        </a>
        <div className={styles.left__btn_container}>
          <Tooltip
            title={'Annuler Ctrl+Z'}
            placement="bottom"
            color="black"
            key={956}
          >
            <div
              className={`${styles.left__svg} ${
                builderContext.formHistory.length > 0
                  ? styles.small__btn_active
                  : ''
              }`}
              onClick={builderContext.undo}
            >
              <div className={styles.left_i__svg}>
                <SvgUndo />
              </div>
            </div>
          </Tooltip>

          <Tooltip
            title={'Répéter Ctrl+Maj+Z'}
            placement="bottom"
            color="black"
            key={9567}
          >
            <div
              className={`${styles.left__svg} ${
                builderContext.undoneStates.length > 0
                  ? styles.small__btn_active
                  : ''
              }`}
              onClick={builderContext.redo}
            >
              <div className={styles.left_i__svg}>
                <SvgRedo />
              </div>
            </div>
          </Tooltip>
        </div>

        <div className={styles.titre_formulaire}>
          {builderContext.styleForm.title_form}
        </div>
      </div>
      <div className={styles.center__container}>
        <div className={styles.container__height}>
          <SizeCanvasButtons />
        </div>
      </div>
      <div className={styles.right__container}>
        <div className={`${styles.container__height} ${styles.flex__end}`}>
          <div className={styles.right__container__flex}>
            <AvatarRoles
              url_code={builderContext.url_code}
              userFullName={builderContext.userFullName}
              userUsername={builderContext.userUsername}
              dataAPI={builderContext.collaboratorsDataAPI}
              showRights={true}
              title={'Personnes pouvant éditer le formulaire'}
              onAddUser={addCollaboratorAPI}
              onEditUser={updateCollaborator}
              onDeleteUser={deleteCollaborator}
              isAdmin={builderContext.isAdmin}
            />

            {builderContext.url_code && (
              <a
                href={PREVIEW_FORM_URL}
                // href={`/workspaces`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className={styles.preview__container}>
                  <SvgPlay />
                  <span>&nbsp;&nbsp;Aperçu</span>
                </div>
              </a>
            )}

            <div className={styles.share__container} onClick={showPublishModal}>
              <div className={styles.copy__link_container}>
                <div className={styles.button__link}>
                  <SvgCopyLink />
                </div>
              </div>
              <div className={styles.share__button}>
                <span>Publier</span>
              </div>
            </div>

            <Modal
              centered
              width={600}
              open={isPublishModalOpen}
              onOk={handleOkPublish}
              onCancel={handleCancelPublish}
              footer={null}
            >
              <div className={styles.container__publish_all}>
                <div className={styles.container__publish}>
                  <div className={styles.container__toggle__publish}>
                    <div className={styles.container__isactive__publish}>
                      {builderContext.styleForm.is_active
                        ? 'Votre formulaire est actif !'
                        : 'Votre formulaire est inactif.'}
                    </div>

                    <div>
                      <Switch
                        checked={builderContext.styleForm.is_active}
                        onChange={handleToggleForm}
                      />
                    </div>
                  </div>

                  <div className={styles.container__title__publish}>
                    {builderContext.styleForm.is_active
                      ? "Partagez un lien ou invitez des utilisateurs à utiliser votre formulaire. Les utilisateurs qui peuvent répondre à ce formulaire dépendent de la façon dont vous l'avez configuré. Vous pouvez le modifier à tout moment."
                      : "C'est vraiment dommage, mais tant que votre formulaire est inactif, personne ne pourra y répondre. C'est une bonne idée de le garder inactif si vous êtes en train de faire des modifications. Cependant, si ce n'est pas le cas, nous vous conseillons de l'activer."}
                  </div>

                  {builderContext.styleForm.is_active ? (
                    <div>
                      <div className={styles.container__url__form__publish}>
                        <div
                          className={styles.container__url__form__publish__url}
                        >
                          {formURL}
                        </div>
                      </div>

                      <div className={styles.container__button_footer_publish}>
                        <div
                          className={styles.callaction__container}
                          onClick={handleCopyLink}
                        >
                          <SvgCopyLink />
                          <span>&nbsp;&nbsp;Copier le lien</span>
                        </div>

                        <div className={styles.callaction__container}>
                          <a
                            href={FORM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              display: 'flex',
                            }}
                          >
                            <SvgPlay />
                            <span>&nbsp;&nbsp;Accéder au formulaire</span>
                          </a>
                        </div>
                      </div>

                      <div className={styles.tabSelectors}>
                        <div className={styles.categoryQRcode}>
                          <div
                            className={`${styles.options_category_QRCODE} ${styles.selected_options_category_QRCODE}`}
                          >
                            QR CODE
                          </div>
                        </div>
                      </div>

                      <div className={styles.qrcode_bloc}>
                        <QRCodeGenerator url={formURL} />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </Modal>

            <Dropdown
              className={styles.dropdown}
              menu={{
                items,
              }}
              trigger={['click']}
            >
              <div className={styles.button__example}>
                <SvgMoreInfo />
              </div>
            </Dropdown>

            <div className={styles.profile}>
              <DropdownProfile width={30} height={30} fontSize={12} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default Header
